import api from "@/lib/axios";

export const noteService = {
  // Get notes for a specific application
  getNotesByApplicationId: async (applicationId) => {
    try {
      const response = await api.get(`/application/${applicationId}/notes`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch notes: " + error.message);
    }
  },
  fetchNotes: async () => {
    try {
      const response = await api.get("/note-categories");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch notes: " + error.message);
    }
  },
  // Create a new note for an application
  createNote: async (applicationId, newNote) => {
    try {
      const response = await api.post(`/application/${applicationId}/notes`, {
        notes: [newNote]
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to create note: " + error.message);
    }
  },

  // Update an existing note
  updateNote: async (applicationId, noteId, updatedNote) => {
    try {
      const response = await api.put(`/application/${applicationId}/notes/${noteId}`, updatedNote);
      return response.data;
    } catch (error) {
      throw new Error("Failed to update note: " + error.message);
    }
  },

  // Delete a note
  deleteNote: async (applicationId, noteId) => {
    try {
      const response = await api.delete(`/application/${applicationId}/notes/${noteId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to delete note: " + error.message);
    }
  }
};
